import { store } from '@/store';
const MainHeader = () => import('@/components/MainHeader');
const Home = () => import('@/views/common/lookup/Home');
const Status = () => import('@/views/common/lookup/Status');
const Payment = () => import('@/views/common/checkout/Payment');
const Finish = () => import('@/views/common/checkout/Finish');


export default [
    {   /* 投保後查詢主頁 */
        path: '/:type(car|motor)/lookup',
        name: 'CarLookup',
        components: {
            default: Home,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            // 投保後查詢因為要先轉去登入頁, login會看from的params
            // 但直接輸入網址from吃不到params type, 先強制塞進去to的params type 
            if (Object.keys(from.params).length == 0) {
                from.params = JSON.parse(JSON.stringify(to.params));
            }
            
            // 沒有會員登入也不是會員專區導過來的
            if (!store.getters['auth/loggedIn'] && !to.query?.EstimateId) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            next();
        }
    },
    {   /* 查詢結果 */
        path: '/:type(car|motor)/lookup/status',
        name: 'CarLookupStatus',
        components: {
            default: Status,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            if (!store.state.lookup.loadedAt) {
                return next({name: 'CarLookup'});
            }

            next();
        }
    },
    {   /* 投保後查詢 新保付款 */
        path: '/:type(car|motor)/lookup/checkout/payment',
        name: 'CarLookupCheckoutPayment',
        components: {
            default: Payment,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 無付款方式，踢回上一頁
            if (!store.state.policy.payWays.length) {
                return next(from);
            }

            next();
        }
    },
    {
        /* 投保後查詢 新保結帳完成頁 */
        path: '/:type(car|motor)/lookup/checkout/finish',
        name: 'CarLookupCheckoutFinish',
        components: {
            default: Finish,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            next();
        }
    },
    {   /* 投保後查詢 續保付款 */
        path: '/:type(car|motor)/lookup/renew/checkout/payment',
        name: 'CarLookupRenewCheckoutPayment',
        components: {
            default: Payment,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 無付款方式，踢回上一頁
            if (!store.state.policy.payWays.length) {
                return next(from);
            }

            next();
        }
    },
    {
        /* 投保後查詢 續保結帳完成頁 */
        path: '/:type(car|motor)/lookup/renew/checkout/finish',
        name: 'CarLookupRenewCheckoutFinish',
        components: {
            default: Finish,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            next();
        }
    }
];